import React from "react";
import { IconType } from "./types";

const CheckMark: IconType = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M14.162 3.464a1.103 1.103 0 0 1 1.523 0c.415.402.42 1.05.015 1.457l-8.601 9.7a1.103 1.103 0 0 1-1.549.029L.315 9.59a1.016 1.016 0 0 1 0-1.472 1.103 1.103 0 0 1 1.523 0l4.44 4.292 7.856-8.915a.349.349 0 0 1 .028-.03Z"
      fill="inherit"
    />
  </svg>
);

export default CheckMark;
